import { ICreateDepositOrderValues } from '@epi-models/containers/LoadCompanyAccount';
import { createSelector } from 'reselect';

import { MIN_ALLOWED_BALANCE } from '../constants/topupForm';
import { CompanyAccountInfo } from '../reducers/api/transactionEstimation';

export const getCompanyAccounts = (state): ICreateDepositOrderValues[] =>
  state.apiCompanyAccounts.companyInfo.accounts;

export const getCompanyNotification = (state): boolean =>
  state.apiCompanyAccounts.showNotification;

export const getCompanyInvoicePFD = (state): boolean =>
  state.apiCompanyAccounts.isPrintInvoicePdfForTransferMoney;

export const getMainCompanyAccount = createSelector(
  getCompanyAccounts,
  (accounts: ICreateDepositOrderValues[]): ICreateDepositOrderValues => {
    return (
      (accounts || []).find(v => !v.parentAccountId) ||
      ({} as ICreateDepositOrderValues)
    );
  }
);

export const floorToCents = (value: number): number => {
  const [intPart, fracPart] = value.toString().split('.');
  return Number(fracPart ? `${intPart}.${fracPart.slice(0, 2)}` : intPart);
};

export const getMainAvailableBalance = createSelector(
  getMainCompanyAccount,
  account => {
    const balance =
      (account as ICreateDepositOrderValues).availableBalance || 0;
    if (balance >= MIN_ALLOWED_BALANCE && balance < 0) return 0;
    return floorToCents(balance);
  }
);

export const getCompanyInfo = (state): Partial<CompanyAccountInfo> => ({
  eInvoiceAddress: state.apiCompanyAccounts.companyInfo.eInvoiceAddress,
  operator: state.apiCompanyAccounts.companyInfo.operator
});
